import React from 'react';
import { useTranslation } from 'react-i18next';
import ValeComponentActivableCanjeable from '../ValeComponentActivableCanjeable';

const CuponNoPromocion = ({
  clasesBloqueValeValor,
  oferta,
  data,
  dataApp,
  unidad,
  isPromocion,
}) => {
  const { t } = useTranslation();

  const textoReclamo = () => {
    if (data?.textoReclamo?.toUpperCase() === 'GRATIS') {
      return (
        <>
          <span className="bloque-vale__gratis">
            {t('vales.gratis').toUpperCase()}
          </span>
        </>
      );
    }
    return null;
  };

  const offer = () => {
    return (
      <span className="bloque-vale__num ">
        {oferta}
        <sup>{unidad}</sup>
      </span>
    );
  };

  const isLangEU = () => {
    return dataApp.lang === 'eu' && unidad === '%';
  };

  const offerEU = () => {
    return (
      <span className="bloque-vale__num">
        <sup>{unidad}</sup>
        {oferta}
      </span>
    );
  };
  const isFree = () => {
    return data?.textoReclamo?.toUpperCase() === 'GRATIS';
  };

  return (
    <div
      className={`${clasesBloqueValeValor}
                     ${oferta.length > 2 ? 'bloque-vale__num-redu' : ''}`}
    >
      {isFree() && textoReclamo()}
      {!isFree() && isLangEU() && offerEU()}
      {!isFree() && !isLangEU() && offer()}
      {!isPromocion && <ValeComponentActivableCanjeable vale={data} />}
    </div>
  );
};

export default CuponNoPromocion;
